import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useAuth } from '@primaveralabs/auth';
import { LoginButton } from '../MusicMeets/Agenda';
import { LinkWrapper } from '../../../util/link';
import { useRoutes } from '../../../context/routesContext';
import translateObj from '../../../util/translateObj';
import Spacer from '../Spacer';

const DEFAULT_TRANSLATIONS = {
  description: {
    en: 'You need to be logged in or create an account to view this content.',
    es: 'Necesitas estar logeado o crear una cuenta para ver este contenido.',
    ca: 'Necessites estar registrat o crear un compte per veure aquest contingut.',
    pt: 'Você precisa estar logado ou criar uma conta para ver este conteúdo',
  },
};

const LoginPaywall = ({ image, terms, termsLink, description, background }) => {
  const { language, path } = useRoutes();
  const { user } = useAuth();
  if (user) return null;
  const gradient = background && background.start && background.end
  ? {
    background: `linear-gradient(135deg, ${background.start}, ${background.end})`,
  }
  : {};
  const fontVariantKey = "gtamerica";
  
  return (
    <div className='w-full flex flex-col items-center sm:px-0 px-5' style={gradient}>
      <Spacer className="mt-10" />
      {
        Object.keys(image).length > 0 ? (
          <div className="max-w-xssm">
            <img src={translateObj(image, language)} />
          </div>
        ) : null
      }
      <Spacer className="mt-10" />
      <div className='w-full flex flex-col items-center bg-white rounded-xl px-5 max-w-2xl'>
        <div className='text-xl sm:text-lg tracking-tight text-center'>
          <LoginButton translation={{ textLogin: description }} fontVariantKey={fontVariantKey}/>
        </div>
        {
          terms?
            <LinkWrapper url={termsLink} target="_blank" path={path} className="text-black underline pb-8">
              {terms[language]}
            </LinkWrapper>
            : null
        }
      </div>
      <Spacer className="mt-20" />
    </div>
  );
};

LoginPaywall.propTypes = {
  image: PropTypes.string,
  terms: PropTypes.shape({
    en: PropTypes.string,
    es: PropTypes.string,
    ca: PropTypes.string,
    pt: PropTypes.string,
  }),
  termsLink: PropTypes.string,
  description: PropTypes.string, // Add validation for description
  background: PropTypes.shape({
    start: PropTypes.string,
    end: PropTypes.string,
  }),
};

LoginPaywall.defaultProps = {
  image: null, // or any default value you prefer
  terms: null, // or any default value you prefer
  termsLink: null, // or any default value you prefer
  description: DEFAULT_TRANSLATIONS.description,
  background: { start: '', end: '' },
};

export default LoginPaywall;
